// import React from 'react';
import styles from './ProBadge.module.sass';

// Simple badge to show on pro-only pages
export const ProBadge = ({ message = "Pro Feature" }) => {
  return (
    <div className={styles.proBadgeContainer}>
      <div className={styles.proBadge}>
        <svg className={styles.proBadgeIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 15L8.5 10L15.5 10L12 15Z" fill="currentColor"/>
          <path d="M12 2L20 7V17L12 22L4 17V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        PRO
      </div>
      {message && <span className={styles.proMessage}>{message}</span>}
    </div>
  );
};

// Pro+ badge for premium tier features
export const ProPlusBadge = ({ message = "Pro+ Feature" }) => {
  return (
    <div className={styles.proBadgeContainer}>
      <div className={styles.proPlusBadge}>
        <svg className={styles.proPlusBadgeIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L14.09 8.26L20.81 9.27L16.41 13.54L17.54 20.22L12 16.91L6.46 20.22L7.59 13.54L3.19 9.27L9.91 8.26L12 2Z" fill="currentColor"/>
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" opacity="0.5"/>
        </svg>
        PRO+
      </div>
      {message && <span className={styles.proMessage}>{message}</span>}
    </div>
  );
};

// Small badge for tab labels
export const ProBadgeSmall = () => {
  return (
    <span className={styles.proBadgeSmall}>PRO</span>
  );
};

// Small Pro+ badge for tab labels
export const ProPlusBadgeSmall = () => {
  return (
    <span className={styles.proPlusBadgeSmall}>PRO+</span>
  );
};

// Overlay for non-subscribers
export const ProLockOverlay = ({ onUpgrade, tier = "pro" }) => {
  const isPlusFeature = tier === "pro+";
  
  return (
    <div className={styles.proLockOverlay}>
      <div className={styles.proLockContent}>
        <svg className={styles.lockIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" fill="currentColor" fillOpacity="0.2"/>
          <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11M5 11H19C20.1046 11 21 11.8954 21 13V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V13C3 11.8954 3.89543 11 5 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="12" cy="16" r="1" fill="currentColor"/>
        </svg>
        <h3 className={styles.lockTitle}>
          {isPlusFeature ? "Pro+ Feature Locked" : "Pro Feature Locked"}
        </h3>
        <p className={styles.lockDescription}>
          {isPlusFeature 
            ? "This premium feature is available exclusively to Pro+ subscribers. Upgrade to Pro+ for advanced analytics, unlimited access, and priority support."
            : "This premium analytics feature is available exclusively to Pro subscribers. Upgrade your plan to access detailed holder analytics and unlock powerful insights."
          }
        </p>
        <button 
          className={isPlusFeature ? styles.upgradePlusButton : styles.upgradeButton} 
          onClick={onUpgrade}
        >
          {isPlusFeature ? "Upgrade to Pro+" : "Upgrade to Pro"}
        </button>
      </div>
    </div>
  );
};

// ProSection wrapper component
export const ProSection = ({ 
  membershipStatus = null, 
  children, 
  onUpgrade = () => {},
  tier = "pro" // "pro" or "pro+"
}) => {
  // Check if user has pro access - max_wallets > 1 indicates a paid account
  const hasProAccess = membershipStatus?.max_wallets > 0;
  const hasProPlusAccess = membershipStatus?.max_wallets > 10; // Adjust threshold as needed
  
  const shouldShowOverlay = tier === "pro+" ? !hasProPlusAccess : !hasProAccess;
  
  return (
    <div style={{ position: 'relative' }}>
      {children}
      {shouldShowOverlay && <ProLockOverlay onUpgrade={onUpgrade} tier={tier} />}
    </div>
  );
};

export default ProBadge;